/*
 * SWAE product page rows ("You may also like", "Recently viewed"), 2026-11. Markup: snippets/swae-pdp-row.liquid.
 *
 * The theme's own section classes fetch the rows and handle Add to Cart and the quick view popup; this file only
 * runs the strip once the markup is in the page:
 * - flat strip on native scroll: touch keeps the browser's swipe and snap; mouse and pen drag, arrows, arrow keys and
 *   trackpad use the shared gesture and easing in assets/swae-bestsellers-drag.js (the homepage carousels' file);
 * - the leading card (centred card on phones) is "featured": its --f goes 0 to 1 with the live scroll position and
 *   drives the gold glow, lift and image zoom, so the incoming card takes it over during a drag;
 * - seamless loop (a clone set either side) and a "current / total" counter when the cards do not all fit; when they
 *   fit, the row is static with no arrows;
 * - "Recently viewed" drops products already shown in "You may also like" on the same page;
 * - an empty row hides its whole section.
 * The strip follows sections/Collection-Carousel.liquid (Shop by Category, homepage), written for product cards.
 */
(function () {
  if (customElements.get('swae-pdp-row')) return;
  var RECS_WAIT_MS = 4000;     // how long "Recently viewed" waits for "You may also like" before de-duplicating
  var PENDING_GIVE_UP_MS = 12000; // a row whose fetch never arrives stops holding space after this

  var handleOf = function (card) {
    var a = card.querySelector('.swae-bs__title a');
    return a ? a.pathname.split('/').pop() : '';
  };
  var hideSection = function (el) {
    var section = el.closest('.shopify-section');
    // A class with !important, because the theme sets style.display = "block" right after inserting the row.
    if (section) section.classList.add('swae-pdp-hidden');
  };
  var recsReady = function (handles) {
    if (window.__swaePdpRecs) return;
    window.__swaePdpRecs = handles;
    document.dispatchEvent(new CustomEvent('swae-pdp:recs-ready'));
  };

  class SwaePdpRow extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if (this.parentElement) this.parentElement.classList.remove('swae-pdp-pending');
      var cards = Array.prototype.slice.call(this.querySelectorAll('.swae-bs__card'));

      if (!cards.length) {
        if (this.getAttribute('data-role') === 'recommendations') recsReady([]);
        hideSection(this);
        return;
      }
      // A row that lands after the give-up timer hid its section comes back.
      var section = this.closest('.shopify-section');
      if (section) section.classList.remove('swae-pdp-hidden');

      if (this.getAttribute('data-role') === 'recommendations') {
        recsReady(cards.map(handleOf));
        this.whenDrag();
        return;
      }

      // "Recently viewed": take out products "You may also like" shows. Wait for that row (invisible, space held) up
      // to RECS_WAIT_MS; if it lands later, its duplicates are taken out then.
      var recsSection = document.querySelector('[data-swae-pdp-recs]');
      var recsPending = recsSection && !window.__swaePdpRecs && !recsSection.closest('.shopify-section').classList.contains('swae-pdp-hidden');
      if (!recsPending) { this.prune(window.__swaePdpRecs || []); return; }
      this.classList.add('is-waiting');
      var waited = false;
      var release = function () {
        if (waited) return;
        waited = true;
        this.classList.remove('is-waiting');
        this.prune(window.__swaePdpRecs || []);
      }.bind(this);
      document.addEventListener('swae-pdp:recs-ready', function () {
        if (waited) this.prune(window.__swaePdpRecs || []); else release();
      }.bind(this), { once: true });
      setTimeout(release, RECS_WAIT_MS);
    }

    // Remove cards whose product is in `taken`; hide the section if none are left, else (re)start the strip.
    prune(taken) {
      var removed = false;
      Array.prototype.slice.call(this.querySelectorAll('.swae-bs__card:not([data-swae-clone])')).forEach(function (c) {
        if (taken.indexOf(handleOf(c)) !== -1) { c.remove(); removed = true; }
      });
      if (!this.querySelector('.swae-bs__card:not([data-swae-clone])')) { hideSection(this); return; }
      if (!this.ready) { this.whenDrag(); return; }
      if (removed) { this.index(); this.static = undefined; this.layout(); }
    }

    // Number the real cards (aria label "2 of 6: title") after the list is final.
    index() {
      this.originals = Array.prototype.slice.call(this.track.querySelectorAll('.swae-bs__card:not([data-swae-clone])'));
      this.n = this.originals.length;
      this.originals.forEach(function (card, i) {
        var t = card.querySelector('.swae-bs__title a');
        card.setAttribute('data-index', i);
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', (i + 1) + ' of ' + this.n + ': ' + (t ? t.textContent.trim() : ''));
      }, this);
    }

    whenDrag() {
      if (window.SwaeDrag) this.setup();
      else document.addEventListener('swae-drag:ready', this.setup.bind(this), { once: true });
    }

    setup() {
      if (this.ready) return;
      this.ready = true;
      var D = this.D = window.SwaeDrag;
      var track = this.track = this.querySelector('[data-swae-pdp-track]');
      this.controls = this.querySelector('[data-swae-pdp-controls]');
      this.counter = this.querySelector('[data-swae-pdp-count]');
      this.index();
      this.cancel = null; this.target = null; this.busy = false; this.idle = null; this.frame = null;

      track.addEventListener('scroll', function () {
        this.schedulePaint();
        if (this.static) return;
        track.classList.add('is-moving');
        clearTimeout(this.idle);
        this.idle = setTimeout(function () { track.classList.remove('is-moving'); this.recentre(); }.bind(this), 150);
      }.bind(this), { passive: true });

      this.querySelectorAll('[data-swae-pdp-dir]').forEach(function (b) {
        b.addEventListener('click', function () { this.stepBy(parseInt(b.getAttribute('data-swae-pdp-dir'), 10)); }.bind(this));
      }, this);
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.stepBy(1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.stepBy(-1); }
      }.bind(this));

      // Mouse and pen drag (touch keeps native scrolling): the strip follows the pointer 1:1, then settles.
      var start = 0;
      D.gesture(track, {
        start: function () { if (this.static) return; this.stop(); this.busy = true; this.snapOff(); start = track.scrollLeft; }.bind(this),
        move: function (dx) { if (!this.static) track.scrollLeft = start - dx; }.bind(this),
        end: function (dx, v) {
          if (this.static) return;
          var step = this.step();
          this.settleTo(D.snapTarget((start - dx) / step, start / step, v));
        }.bind(this),
        tap: function () {
          if (this.static) return;
          var p = track.scrollLeft / this.step();
          if (Math.abs(p - Math.round(p)) > 0.01) this.settleTo(this.target != null ? this.target : Math.round(p));
          else { this.busy = false; this.snapOn(); }
        }.bind(this)
      }, { types: ['mouse', 'pen'] });
      D.wheel(track, function (dx) {
        if (this.static) return;
        this.stop(); this.busy = true; this.snapOff(); track.scrollLeft += dx;
      }.bind(this), function () { if (!this.static) this.settleTo(Math.round(track.scrollLeft / this.step())); }.bind(this));

      // "Added" on the one-click buttons after the theme's own add succeeds (same as the homepage rows).
      document.documentElement.addEventListener('product:added', function (e) {
        var btn = e.detail && e.detail.button;
        if (!btn || !this.contains(btn) || !btn.hasAttribute('data-swae-bs-add')) return;
        btn.classList.add('is-added');
        btn.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = 'Add to Cart'; }, 2500);
      }.bind(this));

      var lastW = window.innerWidth;
      window.addEventListener('resize', function () {
        if (window.innerWidth === lastW) return;
        lastW = window.innerWidth;
        this.layout();
      }.bind(this), { passive: true });
      this.layout();
    }

    step() {
      return this.originals[0].offsetWidth + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
    }
    snapOff() { this.track.style.scrollSnapType = 'none'; this.track.style.scrollBehavior = 'auto'; }
    snapOn() { this.track.style.scrollSnapType = ''; this.track.style.scrollBehavior = ''; }
    stop() { if (this.cancel) { this.cancel(); this.cancel = null; } }

    // Loop when the cards do not all fit; static row otherwise. Re-run on width changes.
    layout() {
      var track = this.track, cs = getComputedStyle(track);
      var room = track.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      var step = this.step();
      var fits = this.n * step - (step - this.originals[0].offsetWidth) <= room + 1;
      var keep = this.static === false ? this.currentIndex() : 0;
      if (fits === this.static) { this.jumpTo(keep); return; }
      this.stop();
      Array.prototype.slice.call(track.querySelectorAll('[data-swae-clone]')).forEach(function (c) { c.remove(); });
      this.static = fits;
      this.classList.toggle('is-static', fits);
      if (this.controls) this.controls.hidden = fits;
      if (!fits) {
        var clone = function (card) {
          var c = card.cloneNode(true);
          c.setAttribute('data-swae-clone', '');
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('aria-label');
          c.querySelectorAll('[id]').forEach(function (el) { el.removeAttribute('id'); });
          c.querySelectorAll('a, button, input, select, textarea').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
          return c;
        };
        var first = track.firstChild;
        this.originals.forEach(function (card) { track.insertBefore(clone(card), first); });
        this.originals.forEach(function (card) { track.appendChild(clone(card)); });
      }
      this.cards = Array.prototype.slice.call(track.querySelectorAll('.swae-bs__card'));
      this.jumpTo(keep);
    }

    // Index (0..n-1) of the featured card.
    currentIndex() {
      var k = Math.round(this.track.scrollLeft / this.step()) - (this.static ? 0 : this.n);
      return ((k % this.n) + this.n) % this.n;
    }

    jumpTo(k) {
      this.snapOff();
      this.track.scrollLeft = this.static ? 0 : (this.n + k) * this.step();
      this.snapOn();
      this.paint();
    }

    schedulePaint() { if (!this.frame) this.frame = requestAnimationFrame(this.paint.bind(this)); }

    paint() {
      this.frame = null;
      var cards = this.cards || this.originals;
      var pos = this.static ? -9 : this.track.scrollLeft / this.step();
      for (var i = 0; i < cards.length; i++) {
        var f = Math.max(0, 1 - Math.abs(i - pos));
        if (Math.abs((cards[i].__f || 0) - f) > 0.001) { cards[i].style.setProperty('--f', f.toFixed(3)); cards[i].__f = f; }
      }
      if (this.counter && !this.static) {
        var text = (this.currentIndex() + 1) + ' / ' + this.n;
        if (this.counter.textContent !== text) this.counter.textContent = text;
      }
    }

    // Seamless loop: when the strip rests inside a clone set, jump by one set (same picture).
    recentre() {
      if (this.busy || this.static) return;
      var track = this.track, setWidth = this.step() * this.n, max = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft < setWidth - 5) { this.snapOff(); track.scrollLeft += setWidth; this.snapOn(); }
      else if (track.scrollLeft > max - setWidth + 5) { this.snapOff(); track.scrollLeft -= setWidth; this.snapOn(); }
      this.schedulePaint();
    }

    settleTo(k) {
      this.stop();
      var track = this.track, step = this.step();
      this.target = k;
      this.busy = true;
      this.snapOff();
      this.cancel = this.D.tween(track.scrollLeft, k * step, k - track.scrollLeft / step,
        function (x) { track.scrollLeft = x; },
        function () { this.cancel = null; this.busy = false; this.target = null; this.snapOn(); this.recentre(); }.bind(this));
    }

    // Arrows and keys; repeated presses during a settle queue up from its target.
    stepBy(d) {
      if (this.static || !d) return;
      var base = this.cancel && this.target != null ? this.target : Math.round(this.track.scrollLeft / this.step());
      this.settleTo(base + d);
    }
  }
  customElements.define('swae-pdp-row', SwaePdpRow);

  // A row whose fetch never arrives (network error) stops holding space; "Recently viewed" stops waiting for it.
  setTimeout(function () {
    document.querySelectorAll('.swae-pdp-pending').forEach(function (holder) {
      console.warn('[swae-pdp] row did not load; hiding it', holder.closest('[data-section-id]'));
      holder.classList.remove('swae-pdp-pending');
      hideSection(holder);
      if (holder.closest('[data-swae-pdp-recs]')) recsReady([]);
    });
  }, PENDING_GIVE_UP_MS);
})();
